<template>
  <Knowledge :type="2" />
</template>

<script>
import Knowledge from '@/components/experimentation/knowledge.vue'
export default {
  components: { Knowledge },
}
</script>